/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
var ns = "[Blueprint]";
var deprec = ns + " DEPRECATION:";
export var POPOVER2_WARN_DEPRECATED_IS_DISABLED = deprec + " <Popover2> isDisabled is deprecated. Use disabled.";
export var POPOVER2_WARN_DEPRECATED_IS_MODAL = deprec + " <Popover2> isModal is deprecated. Use hasBackdrop.";
export var POPOVER2_WARN_DEPRECATED_POSITION = deprec + " <Popover2> position is deprecated. Use placement.";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@blueprintjs/labs/dist/esm/common/errors.js
// module id = 1013
// module chunks = 0